module.exports = __webpack_public_path__ + "media/images/front/icon_square_quadl-c42c0116d8f6da4fc362dac5113aa872.svg";